module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "fullHeight",
    attrs: {
      "id": "integration-confirmation"
    }
  }, [_c('mu-flexbox', {
    staticStyle: {
      "height": "100%"
    },
    attrs: {
      "justify": "center",
      "align": "center"
    }
  }, [_c('mu-flexbox-item', {
    staticClass: "white",
    attrs: {
      "align": "center"
    }
  }, [_c('mu-row', [_c('mu-col', {
    attrs: {
      "width": "100",
      "tablet": "33",
      "desktop": "33"
    }
  }), _vm._v(" "), _c('mu-col', {
    attrs: {
      "width": "100",
      "tablet": "33",
      "desktop": "33",
      "align": "center"
    }
  }, [(_vm.type === 'FITBIT') ? _c('div', [_c('img', {
    attrs: {
      "src": "static/integrations/fitbit.svg",
      "width": "20%"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "title"
  }, [_vm._v("\n              Congratulations!\n            ")]), _vm._v(" "), _c('div', {
    staticClass: "subTitle"
  }, [_vm._v("\n              You are now integrated with FitBit\n            ")])]) : _vm._e(), _vm._v(" "), (_vm.type === 'STRIIV') ? _c('div', [_c('img', {
    attrs: {
      "src": "static/integrations/striiv.png",
      "width": "20%"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "title"
  }, [_vm._v("\n              Congratulations!\n            ")]), _vm._v(" "), _c('div', {
    staticClass: "subTitle"
  }, [_vm._v("\n              You are now integrated with Striiv\n            ")])]) : _vm._e()]), _vm._v(" "), _c('mu-col', {
    attrs: {
      "width": "100",
      "tablet": "33",
      "desktop": "33"
    }
  })], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-47f091d6","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/IntegrationConfirmation/IntegratedConfirmation.vue
// module id = 3706
// module chunks = 1